import { ORG_APIS } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

interface IOrgSubServiceByFilter {
  sub_service_id: string;
  sub_service_name: string;
  duration: string;
}

interface IOrgServiceByFilter {
  service_id: string;
  service_name: string;
  sub_services: IOrgSubServiceByFilter[];
}

export interface IOrgServiceTypeByFilter {
  id: string;
  name: string;
  services: IOrgServiceByFilter[];
}

interface IOrgServicesByFilterResponse {
  status: boolean;
  message: string;
  data: {
    service_types: Record<string, IOrgServiceTypeByFilter>;
  };
}

export const useOrgServicesByFilterAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [serviceTypes, setServiceTypes] = useState<IOrgServiceTypeByFilter[]>([]);

  const execute = useCallback(
    async (options?: { filterType?: string }) => {
      const filterType = options?.filterType ?? "all";

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const res: AxiosResponse<IOrgServicesByFilterResponse> = await axios.get(ORG_APIS?.SERVICES_LIST?.baseURL ?? "", {
          params: {
            filter_type: filterType,
          },
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const finalData = res.data.status ? Object.values(res.data?.data?.service_types ?? {}) : [];
        setServiceTypes(finalData);
        return finalData;
      } catch (error) {
        const e = error as AxiosError;
        if (e.config?.["curlCommand"]) {
          sendCurl(e.config["curlCommand"]);
        }
        setServiceTypes([]);
        return [];
      }
    },
    [configuration, sendCurl],
  );

  return {
    serviceTypes,
    execute,
  };
};
